import {
    ISiteConfigLayouts,
    ISportFeedWidgetProps,
    HomePageSectionsEnum,
} from "@finbackoffice/fe-core";
import { HoursRange } from "@finbackoffice/websocket-client";
import { useSiteConfig } from "./useSiteConfig";

export const usePrematchUpcomingWidgetConfig = () => {
    const prematchUpcomingWidgetConfig = useSiteConfig<ISiteConfigLayouts>(
        "layouts",
    )?.homePage?.widgets?.find(
        (widget): widget is ISportFeedWidgetProps<HomePageSectionsEnum.PrematchUpcoming> =>
            widget.name === HomePageSectionsEnum.PrematchUpcoming && widget.enable,
    );

    if (prematchUpcomingWidgetConfig && !prematchUpcomingWidgetConfig?.timeRange) {
        prematchUpcomingWidgetConfig.timeRange = HoursRange.SIX;
    }

    return prematchUpcomingWidgetConfig;
};
